import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import MicrioViewer from '@/components/MicrioViewer.vue'
import { HOME_MICRIO_ID, pageByTitle } from '@/config/pages'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const activeMicrioId = computed(() => route.meta.micrioId ?? HOME_MICRIO_ID)

function onActivate(payload: { title: string }) {
	const page = pageByTitle(payload.title)
	if (!page) {
		console.warn('[door] no page configured for title →', payload.title)
		return
	}
	router.push({ name: page.route })
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(route).meta.standalone)
      ? (_openBlock(), _createBlock(MicrioViewer, {
          key: 0,
          "image-id": activeMicrioId.value,
          "door-duration": 700,
          "pause-between": 0,
          "zoom-duration": 1000,
          "handoff-hold": 200,
          "handoff-duration": 350,
          onDoorActivate: onActivate
        }, null, 8, ["image-id"]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    })
  ], 64))
}
}

})